module.exports = __webpack_public_path__ + "assets/img/bottom.56972243.png";